import { LOADING_REGISTER, LOADING_UNREGISTER } from '../actions/actionTypes';

export default function (state = 0, action) {
    const { type } = action;

    switch (type) {
        case LOADING_REGISTER:
            return state + 1;
        case LOADING_UNREGISTER:
            return state - 1;
        default:
            return state;
    }

}
